import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ICO_ABI } from "../../Contract/ICO_ABI";
import { ICO_CONTRACT_ADDRESS } from "../../utils/constant";
import { toast } from "react-toastify";
import { useWriteContract, usePublicClient } from "wagmi";
import { useAppKitAccount } from "@reown/appkit/react";
import Loader from "../Loader/Loader";
import { isValidEVMAddress } from "../../utils/helper";
import { readContract } from "@wagmi/core";
import { config } from "../../config";
import { parseEther } from "viem";


const WithdrawModal = ({ show, handleClose }) => {
  const [toAddress, setToAddress] = useState("");
  const [tokenAddress, setTokenAddress] = useState("");
  const [amount, setAmount] = useState("");

  const [loading, setLoading] = useState(false);

  const { writeContractAsync } = useWriteContract();
  const publicClient = usePublicClient();
  const { address } = useAppKitAccount();

  // -----------------------------
  // Withdraw Token Handler
  // -----------------------------
  const handleWithdrawToken = async () => {
    if (!isValidEVMAddress(tokenAddress)) {
      return toast.error("Invalid token address!");
    }
    if (!isValidEVMAddress(toAddress)) {
      return toast.error("Invalid receiver address!");
    }
    if (!amount || Number(amount) <= 0) {
      return toast.error("Enter valid amount");
    }

    try {
      setLoading(true);

      const contractData = {
        abi: ICO_ABI,
        address: ICO_CONTRACT_ADDRESS,
        functionName: "withdrawToken",
        args: [
          tokenAddress,         // address token
          toAddress,            // address to
          amount.toString(),    // uint256 amount
        ],
      };

      await readContract(config, {
        ...contractData,
        account: address,
      });

      const tx = await writeContractAsync(contractData);
      const receipt = await publicClient.waitForTransactionReceipt({ hash: tx });

      if (receipt?.status === "success") {
        toast.success("Token withdrawn successfully");
        handleClose();
      }
    } catch (error) {
      toast.error(error?.cause?.reason || error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------
  // Withdraw ETH Handler
  // -----------------------------
 const handleWithdrawETH = async () => {
  if (!isValidEVMAddress(toAddress)) {
    return toast.error("Invalid receiver address!");
  }
  if (!amount || Number(amount) <= 0) {
    return toast.error("Enter valid ETH amount");
  }

  try {
    setLoading(true);

    // Convert 0.00001 → wei
    const weiAmount = parseEther(amount.toString());

    const contractData = {
      abi: ICO_ABI,
      address: ICO_CONTRACT_ADDRESS,
      functionName: "withdrawETH",
      args: [
        toAddress,     // address payable to
        weiAmount,     // uint256 amount in wei
      ],
    };

    await readContract(config, {
      ...contractData,
      account: address,
    });

    const tx = await writeContractAsync(contractData);
    const receipt = await publicClient.waitForTransactionReceipt({ hash: tx });

    if (receipt?.status === "success") {
      toast.success("ETH withdrawn successfully");
      handleClose();
    }
  } catch (error) {
    toast.error(error?.cause?.reason || error?.message || "Transaction failed");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      {loading && <Loader />}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Withdraw Funds</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Receiver Address */}
            <Form.Group className="mb-3">
              <Form.Label>Receiver Address</Form.Label>
              <Form.Control
                placeholder="0xReceiver..."
                value={toAddress}
                onChange={(e) => setToAddress(e.target.value)}
              />
            </Form.Group>

            {/* Token Address */}
            <Form.Group className="mb-3">
              <Form.Label>Token Address (For Token Withdraw Only)</Form.Label>
              <Form.Control
                placeholder="0xToken..."
                value={tokenAddress}
                onChange={(e) => setTokenAddress(e.target.value)}
              />
            </Form.Group>

            {/* Amount */}
            <Form.Group className="mb-3">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>

          {/* Withdraw Token */}
          <Button variant="primary" onClick={handleWithdrawToken}>
            Withdraw Token
          </Button>

          {/* Withdraw ETH */}
          <Button variant="success" onClick={handleWithdrawETH}>
            Withdraw ETH
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WithdrawModal;
